/*
 * Single source of truth for all IEMENTech conference content.
 * Update this file (not the pages) when details change between editions.
 */

export const CONFERENCE = {
  shortName: 'IEMENTech 2027',
  edition: '10th',
  year: 2027,
  fullName:
    '10th International Conference on Electronics, Materials Engineering and Nano-Technology',
  dateLabel: '02 — 04 June 2027',
  dateShort: '2–4 June 2027',
  startDateISO: '2027-06-02T09:00:00+05:30',
  city: 'Guwahati, Assam, India',
  venue: 'Indian Institute of Technology Guwahati',
  venueShort: 'IIT Guwahati',
  organizers:
    'Dept. of ECE, Institute of Engineering & Management, Kolkata and Indian Institute of Technology Guwahati',
  coSponsor: 'IEEE Kolkata Section',
  email: 'iementech@iem.edu.in',
  altEmail: 'iementech.conf@gmail.com',
  phones: ['+91 98309 98392', '+91 98307 80778'],
  landline: '+91-33 2357-2059 / 2969',
  website: 'https://iementech.iem.edu.in/',
  address: 'Indian Institute of Technology Guwahati, North Guwahati, Guwahati, Assam, India',
};

export const STATS = [
  { value: 15, suffix: '+', label: 'Years of Excellence' },
  { value: 5000, suffix: '+', label: 'Students' },
  { value: 200, suffix: '+', label: 'Faculty Members' },
  { value: 50, suffix: '+', label: 'Research Projects' },
];

export const HIGHLIGHTS = [
  {
    id: 'talks',
    title: 'Invited Talks',
    description:
      'Eminent scientists, professors & industrialists sharing their expertise and research insights from academia and industry.',
  },
  {
    id: 'award',
    title: 'Best Paper Award',
    description:
      'Outstanding research papers will be recognized and awarded for their innovation, quality, and contribution to the field.',
  },
  {
    id: 'wie',
    title: 'IEEE WIE Session',
    description:
      "IEEE Women in Engineering sponsored session promoting gender diversity and women's leadership in technology and engineering.",
  },
  {
    id: 'poster',
    title: 'Poster Session',
    description:
      'Interactive poster presentations showcasing latest research findings, innovations, and academic discussions.',
  },
  {
    id: 'industry',
    title: 'Industry Session',
    description:
      'Industry professionals sharing real-world applications, market trends, and career opportunities in technology.',
  },
];

export const TOPICS = [
  {
    title: 'Semiconductor Device Physics',
    description: 'Advanced research in semiconductor materials, device modeling, and quantum effects',
    items: ['Quantum Transport', 'Band Structure Engineering', 'Device Modeling', 'Material Properties'],
  },
  {
    title: 'Nano-Materials & Opto-Electronics',
    description: 'Nanoscale materials and optical electronic devices for next-generation applications',
    items: ['Photonic Devices', 'Optical Sensors', 'Laser Technology', 'Quantum Optics'],
  },
  {
    title: 'Industrial Electronics & Control Systems',
    description: 'Automation, control systems, and industrial IoT for smart manufacturing',
    items: ['Process Automation', 'PLC Systems', 'SCADA', 'Industrial IoT'],
  },
  {
    title: 'VLSI & Embedded Systems',
    description: 'Very Large Scale Integration design and embedded system development',
    items: ['Chip Design', 'System on Chip', 'Embedded Programming', 'Real-time Systems'],
  },
  {
    title: 'Micro-Electronic Device Fabrication',
    description: 'Manufacturing processes for microelectronic components and devices',
    items: ['Lithography', 'Etching Processes', 'Thin Film Deposition', 'Process Integration'],
  },
  {
    title: 'Renewable Energy',
    description: 'Sustainable energy solutions and green technology innovations',
    items: ['Solar Technology', 'Wind Energy', 'Energy Storage', 'Smart Grids'],
  },
  {
    title: 'Wireless Communication & Computing',
    description: 'Advanced wireless technologies and mobile computing systems',
    items: ['5G/6G Networks', 'IoT Communications', 'Edge Computing', 'Mobile Networks'],
  },
  {
    title: 'Signal & Image Processing',
    description: 'Digital signal processing and computer vision technologies',
    items: ['Digital Filters', 'Computer Vision', 'Pattern Recognition', 'Image Enhancement'],
  },
  {
    title: 'AI, ML & IoT',
    description: 'Artificial Intelligence, Machine Learning, and Internet of Things applications',
    items: ['Deep Learning', 'Neural Networks', 'IoT Analytics', 'Edge AI'],
  },
  {
    title: 'MEMS & Sensors',
    description: 'Micro-Electro-Mechanical Systems and advanced sensor technologies',
    items: ['Microsensors', 'Actuators', 'Bio-MEMS', 'Smart Sensors'],
  },
  {
    title: 'Microwave & Antenna',
    description: 'High-frequency electronics and antenna design for communication systems',
    items: ['Antenna Design', 'RF Circuits', 'Microwave Systems', 'Radar Technology'],
  },
  {
    title: 'Robotics & Mechatronics',
    description: 'Integrated mechanical, electrical, and software systems for automation',
    items: ['Autonomous Systems', 'Robot Control', 'Actuator Systems', 'Human-Robot Interface'],
  },
];

export const KEY_DATES = [
  {
    date: 'To be announced',
    title: 'Deadline of Full Paper Submission',
    description:
      'Final deadline for complete paper submissions including all supporting documents and materials.',
    status: 'deadline',
  },
  {
    date: 'To be announced',
    title: 'Acceptance Notification',
    description:
      'Authors will be notified about the acceptance or rejection of their papers along with reviewer comments.',
    status: 'upcoming',
  },
  {
    date: 'To be announced',
    title: 'Camera Ready Paper Submission',
    description:
      'Final version of accepted papers must be submitted incorporating the reviewer suggestions and comments.',
    status: 'deadline',
  },
  {
    date: 'To be announced',
    title: 'Registration Deadline',
    description:
      'Final deadline for conference registration. All participants must complete their registration by this date.',
    status: 'deadline',
  },
];

export const FEES = {
  note: '* 18% GST included in all Indian registration fees',
  columns: ['Early Bird Registration', 'Late Registration', 'IEEE Members'],
  rows: [
    { category: 'Students', values: ['₹9,500', '₹10,000', '₹9,000'] },
    { category: 'Researchers', values: ['₹10,500', '₹11,000', '₹10,000'] },
    { category: 'Industry', values: ['₹12,500', '₹13,000', '₹12,000'] },
    { category: 'Foreign Delegates', values: ['$300', '$350', '$250'] },
  ],
};

export const SPEAKERS = [];

export const COMMITTEES = [
  {
    title: 'Chief Patron',
    members: [
      { name: 'Prof. Devendra Jalihal', affiliation: 'Director, IIT Guwahati' },
      { name: 'Prof. Banani Chakrabarti', affiliation: 'President, IEM and UEM Group, Kolkata' },
    ],
  },
  {
    title: 'Patron',
    members: [
      { name: 'Prof. Sukumar Nandi', affiliation: 'Dean Administration, IIT Guwahati' },
      { name: 'Prof. Satyajit Chakrabarti', affiliation: 'Vice Chancellor, University of Engineering & Management, Kolkata' },
    ],
  },
  {
    title: 'Advisory Chair',
    members: [
      { name: 'Prof. Harshal B Nemade', affiliation: 'Head, Department of Electronics & Electrical Engineering, IIT Guwahati' },
      { name: 'Prof. Malay Gangopadhyay', affiliation: 'Vice Principal, Institute of Engineering & Management, Kolkata' },
    ],
  },
  {
    title: 'Organizing Chair',
    members: [
      { name: 'Prof. Debabrata Sikdar', affiliation: 'Associate Professor, Department of Electronics & Electrical Engineering, IIT Guwahati' },
      { name: 'Prof. P. K. Giri', affiliation: 'Professor, Department of Physics, IIT Guwahati' },
      { name: 'Prof. Ratna Chakrabarty', affiliation: 'Professor, Institute of Engineering & Management, Kolkata' },
      { name: 'Prof. Mili Sarkar', affiliation: 'Professor, Institute of Engineering & Management, Kolkata' },
    ],
  },
  {
    title: 'Technical Program Committee',
    members: [
      { name: 'Prof. Ratna Chakrabarty', affiliation: 'Professor, Institute of Engineering & Management, Kolkata' },
      { name: 'Prof. Mili Sarkar', affiliation: 'Professor, Institute of Engineering & Management, Kolkata' },
      { name: 'Prof. Rishi Maiti', affiliation: 'Assistant Professor, Department of Physics, IIT Guwahati' },
      { name: 'Prof. Uday Maiti', affiliation: 'Associate Professor, Department of Physics, IIT Guwahati' },
      { name: 'Prof. Anirban Dasgupta', affiliation: 'Assistant Professor, Department of Electronics & Electrical Engineering, IIT Guwahati' },
      { name: 'Prof. Sreenath J G', affiliation: 'Assistant Professor, Department of Electronics & Electrical Engineering, IIT Guwahati' },
      { name: 'Dr. Saikat Bhowmik', affiliation: 'Assistant Professor, Department of Physics, IIT Guwahati' },
      { name: 'Prof. Tanmay Dutta', affiliation: 'Assistant Professor, Department of Electronics & Electrical Engineering, IIT Guwahati' },
    ],
  },
  {
    title: 'Publication Committee',
    members: [
      { name: 'Prof. Samit Karmakar', affiliation: 'Assistant Professor, Institute of Engineering & Management, Kolkata' },
      { name: 'Prof. Soumik Kumar Kundu', affiliation: 'Assistant Professor, Institute of Engineering & Management, Kolkata' },
      { name: 'Prof. Kuntal Deka', affiliation: 'Assistant Professor, Department of Electronics & Electrical Engineering, IIT Guwahati' },
      { name: 'Prof. Ashwini Sawant', affiliation: 'Assistant Professor, Department of Electronics & Electrical Engineering, IIT Guwahati' },
    ],
  },
  {
    title: 'Advisory Committee',
    members: [
      { name: 'Prof. Goutam Saha', affiliation: 'Professor, IIT Kharagpur' },
      { name: 'Prof. Alex James', affiliation: 'Professor, Digital University Kerala, IEEE CABS Board of Governors' },
      { name: 'Prof. Debangshu Dey', affiliation: 'Chair IEEE Kolkata section' },
      { name: 'Mr. Kaushal Buch', affiliation: 'Senior Engineer, GMRT, TIFR' },
      { name: 'Prof. S. M. Sameer', affiliation: 'Professor, NIT Calicut, Director Elect (2025-26) at IEEE Region-10 (Asia-Pacific)' },
    ],
  },
  {
    title: 'Finance Committee',
    members: [
      { name: 'Prof. Sreenath J.G.', affiliation: 'Assistant Professor, Department of Electronics & Electrical Engineering, IIT Guwahati' },
      { name: 'Prof. Uday Maiti', affiliation: 'Associate Professor, Dept of Physics, IIT Guwahati' },
    ],
  },
  {
    title: 'Publicity & Promotion Committee',
    members: [
      { name: 'Prof. Rishi Maiti', affiliation: 'Assistant Professor, Dept of Physics, IIT Guwahati' },
      { name: 'Prof. Sreenath J.G.', affiliation: 'Assistant Professor, Department of Electronics & Electrical Engineering, IIT Guwahati' },
      { name: 'Prof. Ratnadwip Singha', affiliation: 'Assistant Professor, Dept of Physics, IIT Guwahati' },
      { name: 'Prof. Ravindra Kumar Jha', affiliation: 'Assistant Professor, Department of Electronics & Electrical Engineering, IIT Guwahati' },
      { name: 'Prof. Vibhav Bharadwaj Shivakumar', affiliation: 'Assistant Professor, Dept of Physics, IIT Guwahati' },
    ],
  },
  {
    title: 'Accommodation Committee',
    members: [
      { name: 'Prof. B. R Manoj', affiliation: 'Assistant Professor, Department of Electronics & Electrical Engineering, IIT Guwahati' },
      { name: 'Prof. Vibhav Bharadwaj Shivakumar', affiliation: 'Assistant Professor, Dept of Physics, IIT Guwahati' },
    ],
  },
  {
    title: 'Transportation Committee',
    members: [
      { name: 'Prof. Saikat Bhaumik', affiliation: 'Assistant Professor, Dept of Physics, IIT Guwahati' },
      { name: 'Prof. Malleswar Rao Tangi', affiliation: 'Assistant Professor, Dept of Physics, IIT Guwahati' },
    ],
  },
  {
    title: 'Food Committee',
    members: [
      { name: 'Kaustab Acharya', affiliation: 'Centre for Nanotechnology, IIT Guwahati' },
      { name: 'Prof. Ravindra Kumar Jha', affiliation: 'Assistant Professor, Department of Electronics & Electrical Engineering, IIT Guwahati' },
    ],
  },
  {
    title: 'Registration Committee',
    members: [
      { name: 'Prof. Mahima Arrawatia', affiliation: 'Assistant Professor, Department of Electronics & Electrical Engineering, IIT Guwahati' },
      { name: 'Prof. Rishikesh Dilip Kulkarni', affiliation: 'Assistant Professor, Department of Electronics & Electrical Engineering, IIT Guwahati' },
      { name: 'Prof. Binoy Krishna Hazra', affiliation: 'Assistant Professor, Dept of Physics, IIT Guwahati' },
    ],
  },
  {
    title: 'Industry Forum & Panel Sessions Committee',
    members: [
      { name: 'Prof. Tanmay Dutta', affiliation: 'Assistant Professor, Department of Electronics & Electrical Engineering, IIT Guwahati' },
      { name: 'Prof. Samudrajit Thapa', affiliation: 'Assistant Professor, Dept of Physics, IIT Guwahati' },
    ],
  },
  {
    title: 'Sponsorship Committee',
    members: [
      { name: 'Prof. Arif Warsi Laskar', affiliation: 'Assistant Professor, Dept of Physics, IIT Guwahati' },
      { name: 'Prof. Kuntal Deka', affiliation: 'Assistant Professor, Department of Electronics & Electrical Engineering, IIT Guwahati' },
    ],
  },
];

/*
 * Committee member portraits, keyed by exact member name.
 * Local files were sourced from iitg.ac.in (EEE/Physics/CSE) and
 * faculty.iem.edu.in / media.iem.edu.in official pages.
 */
const C = '/assets/committee';
export const COMMITTEE_PHOTOS = {
  'Prof. Banani Chakrabarti': '/assets/new/banani.jpg',
  'Prof. Mili Sarkar': '/assets/new/google-mili-sarkar.png',
  'Prof. Devendra Jalihal': `${C}/devendra-jalihal.jpg`,
  'Prof. Sukumar Nandi': `${C}/sukumar-nandi.png`,
  'Prof. Satyajit Chakrabarti': `${C}/satyajit-chakrabarti.jpg`,
  'Prof. Harshal B Nemade': `${C}/harshal-b-nemade.jpg`,
  'Prof. Debabrata Sikdar': `${C}/debabrata-sikdar.jpg`,
  'Prof. P. K. Giri': `${C}/p-k-giri.jpg`,
  'Prof. Ratna Chakrabarty': `${C}/ratna-chakrabarty.jpg`,
  'Prof. Rishi Maiti': `${C}/rishi-maiti.jpg`,
  'Prof. Uday Maiti': `${C}/uday-maiti.jpg`,
  'Prof. Anirban Dasgupta': `${C}/anirban-dasgupta.jpg`,
  'Prof. Sreenath J G': `${C}/sreenath-j-g.jpg`,
  'Prof. Sreenath J.G.': `${C}/sreenath-j-g.jpg`,
  'Dr. Saikat Bhowmik': `${C}/saikat-bhaumik.jpg`,
  'Prof. Saikat Bhaumik': `${C}/saikat-bhaumik.jpg`,
  'Prof. Tanmay Dutta': `${C}/tanmay-dutta.jpg`,
  'Prof. Samit Karmakar': `${C}/samit-karmakar.jpg`,
  'Prof. Soumik Kumar Kundu': `${C}/soumik-kumar-kundu.jpg`,
  'Prof. Kuntal Deka': `${C}/kuntal-deka.jpg`,
  'Prof. Ashwini Sawant': `${C}/ashwini-sawant.jpg`,
  'Prof. Ratnadwip Singha': `${C}/ratnadwip-singha.jpg`,
  'Prof. Ravindra Kumar Jha': `${C}/ravindra-kumar-jha.jpg`,
  'Prof. Vibhav Bharadwaj Shivakumar': `${C}/vibhav-bharadwaj-shivakumar.jpg`,
  'Prof. B. R Manoj': `${C}/b-r-manoj.jpg`,
  'Prof. Malleswar Rao Tangi': `${C}/malleswar-rao-tangi.jpg`,
  'Prof. Binoy Krishna Hazra': `${C}/binoy-krishna-hazra.jpg`,
  'Prof. Mahima Arrawatia': `${C}/mahima-arrawatia.jpg`,
  'Prof. Rishikesh Dilip Kulkarni': `${C}/rishikesh-dilip-kulkarni.jpg`,
  'Prof. Samudrajit Thapa': `${C}/samudrajit-thapa.jpg`,
  'Prof. Arif Warsi Laskar': `${C}/arif-warsi-laskar.jpg`,
  'Prof. Alex James': 'https://duk.ac.in/wp-content/uploads/2021/02/alex-1-600x600.jpg',
  'Mr. Kaushal Buch':
    'https://i1.rgstatic.net/ii/profile.image/618442885455872-1524459682109_Q512/Kaushal-Buch.jpg',
};

export const NAV_LINKS = [
  { to: '/', label: 'Home' },
  { to: '/registration', label: 'Registration' },
  { to: '/topics', label: 'Topics' },
  { to: '/key-dates', label: 'Dates' },
  { to: '/submissions', label: 'Submissions' },
  { to: '/committee', label: 'Committee' },
  { to: '/speakers', label: 'Speakers' },
  { to: '/contact', label: 'Contact' },
];
